<app-page-list [data]="data" [columns]="columns" [queryService]="service.query" [crud]="service" [insertForm]="insertForm" insertFormTitle="parametro" [visibleColumns]="visibleColumns">
  <div insert-form>
    <app-new-form [form]="insertForm"></app-new-form>
  </div>
</app-page-list>
